// Campus photo for /colleges/university-of-richmond: CC BY 2.0, by Andrij Bulba from Slovakia, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Richmond.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-richmond/; credited under the photo.
const photo = {
    "slug": "university-of-richmond",
    "alt": "Collegiate Gothic buildings and a tower reflected in Westhampton Lake at dusk, University of Richmond, Virginia",
    "src": "/colleges/university-of-richmond/campus-1600.webp",
    "srcSmall": "/colleges/university-of-richmond/campus-800.webp",
    "srcMid": "/colleges/university-of-richmond/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-richmond/og.jpg",
    "title": "University of Richmond",
    "author": "Andrij Bulba from Slovakia",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Richmond.jpg",
    "read": "2026-10-01"
};

export default photo;
